import { takeLatest, put, delay } from 'redux-saga/effects';
import * as actions from 'reducer/actionTypes'

export default function* fetchMessageBox() {
	yield takeLatest(actions.FETCH_MESSAGEBOX_REQUEST, messageBox)
}

function* messageBox(param) {
	yield put({
		type: actions.FETCH_MESSAGEBOX_ON,
		message: param.message,
		isError: param.isError,
		resultCode : param.resultCode
	})

	yield delay(3000)

	yield put({
		type: actions.FETCH_MESSAGEBOX_OFF
	})
}

